module.exports = __webpack_public_path__ + "img/fert.f9f9e9c6.png";